import { Anchor, Badge, Box, Card, Flex, Grid, Switch, Tooltip } from '@mantine/core';
import { IconCalendar, IconHistory } from '@tabler/icons-react';
import { useLocation } from 'react-router';
import prettifiedLabel from '../../constants/labelPrettifier';

const defaultWeeksDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const ReportsCards = ({ reports, toggleReport }) => {
  const location = useLocation();

  return reports.map((report, index) => {
    return (
      <Card key={report.id.toString()} withBorder mb="md">
        <Card.Section inheritPadding py="sm">
          <Grid>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <Anchor href={`#${location.pathname}/${report.id}/details`}>
                <strong>{report.name}</strong>
              </Anchor>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <Box c="dimmed">
                <Badge variant="default">{prettifiedLabel(report.scope)}</Badge>
                <Tooltip
                  label={
                    <>
                      <div>Created: {new Date(report.createdAt).toLocaleString()}</div>
                      <div>Updated: {new Date(report.updatedAt).toLocaleString()}</div>
                    </>
                  }
                  position="top"
                  withArrow
                >
                  <Badge variant="default" style={{ cursor: 'pointer' }}>
                    <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                  </Badge>
                </Tooltip>
              </Box>
              <Box c="dimmed">
                {report.type === 'periodic' ? (
                  <>
                    <IconCalendar size={16} style={{ verticalAlign: 'middle' }} />
                    Every <Badge variant="default">{report.schedule.periodicity}</Badge> {report.schedule.scope}s at{' '}
                    {report.schedule.hours.toString().padStart(2, '0')}:
                    {report.schedule.minutes.toString().padStart(2, '0')} UTC
                    {report.schedule.timeZoneOffset === 0
                      ? ''
                      : `${report.schedule.timeZoneOffset > 0 ? '-' : '+'}${Math.abs(
                          report.schedule.timeZoneOffset / 60
                        )}`}{' '}
                    on {report.schedule.scope === 'week' ? '' : 'days'}
                    {report.schedule.days.map((d) => (
                      <Badge key={d} variant="default" mr="xs">
                        {report.schedule.scope === 'week' ? defaultWeeksDays[d] : d}
                      </Badge>
                    ))}
                  </>
                ) : null}
              </Box>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 2 }}>
              {report.type === 'periodic' && (
                <Flex justify="flex-end" align="center" h="100%">
                  <Switch
                    size="lg"
                    defaultChecked={report.running}
                    onChange={(e) => toggleReport(index, e.target.checked)}
                  />
                </Flex>
              )}
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
    );
  });
};

export default ReportsCards;
